import React from "react"
import Link from "gatsby-link"
import { Helmet } from "react-helmet"
import Img from "gatsby-image"
import * as PropTypes from "prop-types"
import Markdown from "../components/Markdown"
import ArticleList from "../components/ArticleList"
import QuoteList from "../components/QuoteList"

import style from "./index.module.css";
import cartbuttonStyle from "../components/Book/cartbutton.module.css";
import detailsStyle from "../components/Book/details.module.css";
import authorStyle from "../components/Book/authorPopular.module.css";

const propTypes = {
  data: PropTypes.object.isRequired,
}

class Home extends React.Component {
  render() {
    const content = this.props.data.page
    const book = this.props.data.book
    const articles = this.props.data.articles
    return (
      <div>
        <Helmet>
          <title>{content.title}</title>
          <meta name="description" content={content.metaDescription} />
          <meta property="fb:app_id" content="155494841970817" />
          <meta property="og:url"         content="https://www.patronenvanbedrog.nl" />
          <meta property="og:type"        content="article" />
          <meta property="og:title"       content={content.title} />
          <meta property="og:description" content={content.metaDescription} />
          <meta property="og:image"       content="https://www.patronenvanbedrog.nl/images/cover3d.jpg" />
        </Helmet>
        <section className={style.content}>
          <div className={style.left}>
            <div className={style.coverContainer}>
              <div className={style.coverWrapper}>
                <img className={style.cover} src="/images/cover3d.jpg" />
              </div>
            </div>
            <section className={style.details}>
              <QuoteList quotes={book.quotes} />
              <div className={style.techDetails}>
              <dl className={detailsStyle.list}>
                <dt className={detailsStyle.title}>Titel</dt>
                <dd className={detailsStyle.definition}>{book.title}</dd>
                <div className={detailsStyle.techItem}>
                  <dt className={detailsStyle.title}>Auteurs</dt>
                  <span>
                    <dd className={detailsStyle.definition}>Willem Middelkoop</dd>
                    <dd className={detailsStyle.definition}>Tim Dollee</dd>
                  </span>
                </div>
                <div className={detailsStyle.techItem}><dt className={detailsStyle.title}>Prijs</dt><dd className={detailsStyle.definition}>{book.price}</dd></div><div className={detailsStyle.techItem}><dt className={detailsStyle.title}>ISBN</dt><dd className={detailsStyle.definition}>9789462987678</dd></div><div className={detailsStyle.techItem}><dt className={detailsStyle.title}>Bindwijze</dt><dd className={detailsStyle.definition}>Paperback</dd></div><div className={detailsStyle.techItem}><dt className={detailsStyle.title}>Aantal pagina's</dt><dd className={detailsStyle.definition}>320</dd></div><div className={detailsStyle.techItem}><dt className={detailsStyle.title}>Publicatiedatum</dt><dd className={detailsStyle.definition}>2018-05-31</dd></div>
              </dl>
              </div>
            </section>
          </div>
          <div className={style.descriptionContainer}>
            <h2 className={style.authorTitle}>{book.authors}</h2>
            <h1 className={style.title}>{book.title}</h1>
            <div className={style.description}>
              <Markdown source={book.description.description} />
            </div>
            <div className={style.cartButton}>
              <a href={book.buyLink} target="_bank">
                <div className={cartbuttonStyle.price}>{book.price}</div>
                <div className={cartbuttonStyle.icon}>+ Bestel het boek</div>
              </a>
            </div>

            <div className={style.authorContainer}>
            <div className={authorStyle.container}>
              <div className={authorStyle.details}>
              <div className={authorStyle.imageContainer}>
                <img className={authorStyle.image} src="/images/willem-middelkoop-square.jpg" />
              </div>
              <Markdown source={book.bio.bio} />
              </div>
            </div>
            </div>
          </div>
        </section>
        <section className={style.articles}>
          <ArticleList articles={articles} />
        </section>
      </div>
    )
  }
}

Home.propTypes = propTypes

export default Home

export const homepageQuery = graphql`
  query homepageQuery {
    page: contentfulPage(contentful_id: { eq: "7m3aLxshqguc6goQs4ueyc" }) {
      title
      metaDescription
    }
    book: contentfulBook(contentful_id: { eq: "4y2F8HEGW4mkEoOACiycoE" }) {
      title
      authors
      metaDescription
      description { description }
      quotes {
        quote { quote }
        source
      }
      price
      buyLink
      bio { bio }
      cover {
        sizes(maxWidth: 1400) {
          sizes
          src
          srcSet
          srcWebp
          srcSetWebp
        }
      }
    }
    articles: allContentfulArticle (sort: {fields: [date], order: DESC}) {
      edges {
        node {
          id
          title
          slug
          date
          description { description }
          source
          link
          image {
            sizes(maxWidth: 800) {
              sizes
              src
              srcSet
              srcWebp
              srcSetWebp
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js